import { createActionGroup, props } from '@ngrx/store';

import { ChatSettings, PatchedPatchChatSettingsRequest } from '@offconon/core-api';

export const ChatChannelListActions = createActionGroup({
  source: 'Chat Channel List',
  events: {
    // Load Channels
    'Update Chat Settings': props<{ settings: PatchedPatchChatSettingsRequest }>(),
    'Update Chat Settings Success': props<{ settings: ChatSettings }>(),
    'Update Chat Settings Failure': props<{ error: string }>(),
  },
});
